@if(showLoadingSpinner()){
<div class="loading-overlay">
    <app-loader></app-loader>
</div>
}